export default __webpack_public_path__ + "static/jewellerybenchmadefromdesk-038ecbee778c6d167fc4571589a232a5.png";